export const WINDOWS_PATH = '/uslugi/gotovye-resheniya-pod-klyuch/okna-na-zakaz/';

export const WINDOWS_ELEMENT_BLOCK = 'landingOkna';

export const WINDOWS_LANDING_NAME = 'windows';

export const WINDOWS_SERVICE_ID = '1525';

export const WINDOWS_CDN_PATH =
  'https://cdn.lemanapro.ru/lmru/image/upload/q_90,f_auto,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/windows';
